module.exports = __webpack_public_path__ + "img/avatar-pressure-low.3e708e17.png";